import apiClient from './apiClient';

// Helper für Onboarding
// Offizielle Gmail und Microsoft Logos als SVG Data-URLs
const GMAIL_ICON = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='52 42 88 66'%3E%3Cpath fill='%234285f4' d='M58 108h14V74L52 59v43c0 3.32 2.69 6 6 6'/%3E%3Cpath fill='%2334a853' d='M120 108h14c3.32 0 6-2.69 6-6V59l-20 15'/%3E%3Cpath fill='%23fbbc04' d='M120 48v26l20-15v-8c0-7.42-8.47-11.65-14.4-7.2'/%3E%3Cpath fill='%23ea4335' d='M72 74V48l24 18 24-18v26L96 92'/%3E%3Cpath fill='%23c5221f' d='M52 51v8l20 15V48l-5.6-4.2c-5.94-4.45-14.4-.22-14.4 7.2'/%3E%3C/svg%3E";

// Microsoft Logo (4 Quadrate)
const OUTLOOK_ICON = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 23 23'%3E%3Crect x='1' y='1' width='10' height='10' fill='%23f25022'/%3E%3Crect x='12' y='1' width='10' height='10' fill='%237fba00'/%3E%3Crect x='1' y='12' width='10' height='10' fill='%2300a4ef'/%3E%3Crect x='12' y='12' width='10' height='10' fill='%23ffb900'/%3E%3C/svg%3E";

export const getEmailProviders = async () => {
  // Hole den echten Verbindungsstatus vom Backend (prüfe 'agent' purpose für KI-Agent)
  let gmailConnected = false;
  let outlookConnected = false;
  let gmailEmail = null;
  let outlookEmail = null;

  try {
    const statusResponse = await apiClient.get('/email/status?purpose=agent');
    const status = statusResponse.data;

    if (status.gmail) {
      gmailConnected = status.gmail.connected || false;
      gmailEmail = status.gmail.email || null;
    }
    if (status.outlook) {
      outlookConnected = status.outlook.connected || false;
      outlookEmail = status.outlook.email || null;
    }
  } catch (err) {
    // Bei Fehler einfach als nicht verbunden anzeigen
    console.log('Konnte E-Mail-Status nicht abrufen:', err.message);
  }

  return {
    providers: [
      {
        id: 'gmail',
        name: 'Gmail',
        icon: GMAIL_ICON,
        isConnected: gmailConnected,
        email: gmailEmail
      },
      {
        id: 'outlook',
        name: 'Outlook / Microsoft 365',
        icon: OUTLOOK_ICON,
        isConnected: outlookConnected,
        email: outlookEmail
      }
    ]
  };
};

export const emailOAuthApi = {
  // Gmail
  gmail: {
    getAuthUrl: async (purpose = 'sending') => {
      const response = await apiClient.get(`/email/gmail/auth?purpose=${purpose}`);
      return response.data;
    },
    getStatus: async (purpose = 'sending') => {
      const response = await apiClient.get(`/email/gmail/status?purpose=${purpose}`);
      return response.data;
    },
    disconnect: async (purpose = 'sending') => {
      const response = await apiClient.delete(`/email/gmail?purpose=${purpose}`);
      return response.data;
    },
    send: async ({ to, subject, body, attachments }, purpose = 'sending') => {
      const response = await apiClient.post(`/email/gmail/send?purpose=${purpose}`, { to, subject, body, attachments });
      return response.data;
    }
  },

  // Outlook
  outlook: {
    getAuthUrl: async (purpose = 'sending') => {
      const response = await apiClient.get(`/email/outlook/auth?purpose=${purpose}`);
      return response.data;
    },
    getStatus: async (purpose = 'sending') => {
      const response = await apiClient.get(`/email/outlook/status?purpose=${purpose}`);
      return response.data;
    },
    disconnect: async (purpose = 'sending') => {
      const response = await apiClient.delete(`/email/outlook?purpose=${purpose}`);
      return response.data;
    },
    send: async ({ to, subject, body, attachments }, purpose = 'sending') => {
      const response = await apiClient.post(`/email/outlook/send?purpose=${purpose}`, { to, subject, body, attachments });
      return response.data;
    }
  },

  // Unified
  getAllStatus: async (purpose = 'sending') => {
    const response = await apiClient.get(`/email/status?purpose=${purpose}`);
    return response.data;
  },

  send: async ({ to, subject, body, attachments }, purpose = 'sending') => {
    const response = await apiClient.post(`/email/send?purpose=${purpose}`, { to, subject, body, attachments });
    return response.data;
  }
};
